import React, { Component } from "react";
import "./Forms.css";
import { Button,Jumbotron} from "react-bootstrap";

import Form from "react-jsonschema-form";


const log = (type) => console.log.bind(console, type);

export default class Home extends Component {
  constructor(props) {
  super(props);
  this.state = {

    form: {"title":"Make a note","type":"object","required":["note"],"properties":{"note":{"type":"string","title":"Note","default":""}}},
    schema:{"note":{"ui:widget":"textarea"}}


};
}

componentDidMount() {
  /* fetch('https://api.myjson.com/bins/'+this.props.match.params.id)
     .then(response => response.json())
     .then(data => this.setState({ form:data }));
     */
 }


 submit =(d)=>{
   //Add the user to the data
    d.formData["formid"]=this.props.match.params.formid
   d.formData["user"]=this.props.match.params.user
   alert(JSON.stringify(d.formData))


 }
  render() {
    return (
      <Jumbotron>

          <p>Patient:{this.props.match.params.user}</p>
          <Form className="lowWidth" schema={this.state.form} uiSchema={this.state.schema}
          onChange={log("changed")}
          onSubmit={this.submit}
          onError={log("errors")} />

        </Jumbotron>

    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Forms.js